'use client';

import Image from 'next/image';
import { Box, Chip, Stack, Typography } from '@/primitives';
import { slate } from '@/lib/colours';
import { FadeInWhenVisible } from './FadeInWhenVisible';
import { landingTrustChips } from './homeLandingContent';
import { lightSectionBg, sectionShell } from './homeLandingSectionSx';

const chipSurface = slate[50];

export function LandingTrustStrip() {
  return (
    <Box
      component="section"
      sx={{
        py: { xs: 3, md: 4 },
        borderBottom: `1px solid ${slate[200]}`,
        ...lightSectionBg,
      }}
    >
      <Box sx={sectionShell}>
        <FadeInWhenVisible>
          <Stack
            alignItems="center"
            direction={{ xs: 'column', md: 'row' }}
            justifyContent="space-between"
            spacing={2}
          >
            <Stack alignItems="center" direction="row" spacing={1.5}>
              <Box
                sx={{
                  position: 'relative',
                  width: 40,
                  height: 40,
                  opacity: 0.85,
                }}
              >
                <Image
                  alt=""
                  fill
                  aria-hidden
                  src="/cow-silhouette.svg"
                  style={{ objectFit: 'contain' }}
                />
              </Box>
              <Typography color={slate[600]} variant="titlemedium">
                Registry-first platform for breed societies and their
                communities
              </Typography>
            </Stack>
            <Stack
              direction="row"
              flexWrap="wrap"
              justifyContent="center"
              spacing={1}
              useFlexGap
            >
              {landingTrustChips.map((label) => (
                <Chip
                  key={label}
                  label={label}
                  size="small"
                  sx={{
                    borderRadius: '8px',
                    border: `1px solid ${slate[200]}`,
                    backgroundColor: chipSurface,
                    color: slate[700],
                    fontWeight: 500,
                    '& .MuiChip-label': { px: 1.5 },
                  }}
                  variant="outlined"
                />
              ))}
            </Stack>
          </Stack>
        </FadeInWhenVisible>
      </Box>
    </Box>
  );
}
